import styled from '@emotion/styled';
import Breakpoints from '../../design-utils/breakpoints';
import Button from '../../components/Button';
import { H3 } from '../../components/Typography';

export const NavSections = styled.nav`
  position: sticky;
  inset: 0;
  top: -1px;
  width: 100%;
  margin: 0 auto;
  padding: 1rem 0;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  z-index: 1;

  @media (max-width: ${Breakpoints.sm}) {
    display: none;
  }
`;

export const SectionTitleButton = styled(Button)`
  text-transform: uppercase;
  font-weight: 400;
  &:hover {
    font-weight: 700;
  }

  &.showed {
    font-weight: 700;
  }
`;

export const SectionTitle = styled(H3)`
  text-align: center;
  text-transform: uppercase;
  margin: 1rem 0;
`;

export const SectionsSection = styled.section`
  width: 100%;
  max-width: 1010px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  overflow-y: auto;
`;

export const SectionLabel = styled.h4`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin: 0;
`;
